import * as React from "react";

const QuickOrder: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="-1 -1 28 28"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fillRule="evenodd"
                d="M16.858 0c.179 0 .325.146.325.325v1.368a.324.324 0 01-.325.325H14.9v1.918c2.269.12 4.352.923 6.055 2.206l1.235-1.468-1.498-1.258a.328.328 0 01-.04-.458l.882-1.047a.325.325 0 01.458-.042l3.89 3.266a.331.331 0 01.117.247c0 .075-.026.15-.078.211l-.88 1.047a.321.321 0 01-.456.042l-1.501-1.258-1.232 1.47a11.023 11.023 0 013.504 8.069C25.357 21.06 20.413 26 14.317 26a11.034 11.034 0 01-9.423-5.285h1.414a9.848 9.848 0 008.008 4.115c5.444 0 9.87-4.426 9.87-9.867 0-5.444-4.426-9.87-9.87-9.87a9.847 9.847 0 00-8.014 4.124H4.888a11.046 11.046 0 018.843-5.281V2.018h-1.953a.324.324 0 01-.325-.325V.325c0-.179.146-.325.325-.325h5.08zm-6.14 17.92c.18 0 .325.147.325.326v.52a.326.326 0 01-.324.325H2.274a.326.326 0 01-.325-.326v-.52c0-.178.146-.325.325-.325h8.444zm8.811-9.57l.4.334a.325.325 0 01.039.458l-4.43 5.278a1.337 1.337 0 01-1.222 1.885 1.34 1.34 0 11.329-2.636l4.426-5.28a.328.328 0 01.458-.04zM8.765 14.38c.182 0 .325.146.325.325v.52a.324.324 0 01-.325.325H.325A.324.324 0 010 15.226v-.52c0-.178.143-.325.325-.325h8.44zm1.954-3.539c.178 0 .325.146.325.325v.52a.324.324 0 01-.325.325H2.274a.324.324 0 01-.325-.325v-.52c0-.179.146-.325.325-.325h8.444z"
            />
        </svg>
    );
};

export default React.memo(QuickOrder);
